import { Flex, Text } from '@chakra-ui/layout'
import React, { useMemo, useState } from 'react'
import { useModalState } from '~/atoms/ModalState'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { usePhoneEndpoint } from '~/hooks/usePhone'
import { Size } from '~/types/ThemeTypes'

import { useNewExtensionSubscriptionModalStyle } from './componentStyles/NewExtensionSubscriptionModal.style'

export const NewExtensionSubscriptionModal = () => {
  const [selectedExtensionIndex, setSelectedExtensionIndex] =
    useState<number>(0)

  const {
    extensionModal: [modalState, setModalState],
  } = useModalState()
  const {
    state: { extensions },
  } = usePhoneEndpoint({})
  const { pbxId } = useUserState()
  const {
    settings: {
      pbx: { extensions: trackedExtensions },
    },
    addTrackedExtension,
  } = useSettingsState(pbxId)

  const availableExtension = useMemo(() => {
    return extensions
      .filter(
        (ext) =>
          !trackedExtensions?.find((trackedExt) => trackedExt.id === ext.id),
      )
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [extensions, trackedExtensions])

  const selectedExtension = availableExtension[selectedExtensionIndex]

  const handleExtensionSelect = (id: number, index: number) => {
    setSelectedExtensionIndex(index)
  }

  const handleClose = () => {
    setModalState({ open: false })
    setSelectedExtensionIndex(0)
  }
  const handleSave = () => {
    addTrackedExtension({
      id: selectedExtension.id,
      name: selectedExtension.name,
      number: selectedExtension.number,
      uuid: selectedExtension.uuid,
    })
    handleClose()
  }

  const styles = useNewExtensionSubscriptionModalStyle()

  return (
    <MangoModal
      isOpen={modalState.open}
      onClose={handleClose}
      header="Add Extension Presence"
      body={
        <Flex sx={styles.bodyContainer}>
          <Flex sx={styles.dropdownContainer}>
            <Text sx={styles.dropdownLabel}>Extension</Text>
            <DropdownSelect
              items={availableExtension.map((ext) => {
                return {
                  value: ext.id,
                  content: (
                    <Flex key={ext.id} sx={styles.itemContainer}>
                      <Text sx={styles.itemText}>{ext.name}</Text>
                      <ExtensionBadge size={Size.sm} extension={ext.number} />
                    </Flex>
                  ),
                  selectedLabel: `${ext.name} - ${ext.number}`,
                }
              })}
              selectedIndex={selectedExtensionIndex}
              onSelect={handleExtensionSelect}
            />
          </Flex>
        </Flex>
      }
      footer={
        <Flex sx={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            Cancel
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleSave}
          >
            Save
          </MangoButton>
        </Flex>
      }
    />
  )
}
